





















import Vue from 'vue'
import { Component, Prop, Emit, Watch } from 'vue-property-decorator'

@Component({
})
export default class AppListSearchBtn extends Vue {
  @Emit()
  submit () {}
}
